;(function () {
    'use strict'

    var root
    var isNode
    if (typeof module !== 'undefined' && module.exports) {
        isNode = true
        root = global
    } else {
        isNode = false
        root = window
    }

    function GameDevice(message, gameNavigation, device, helperFunctions, schemeId, threeRadical) {
        this.device = device
        this.message = message
        this.gameNavigation = gameNavigation
        if(threeRadical) {
            this.threeRadical = threeRadical
        } else {
            this.threeRadical = (((((this.message || {}).quantities || {}).link || {}).data || {}).externalPackage || {}).threeRadical
        }
        let webServices = (this.threeRadical || {}).webServices
        this.services = {}
        
        let self = this
        if (webServices) {
            for(let webService in webServices) {
                this.services[helperFunctions.camelCase(webService)] = function(serviceData) {
                    return self.device.gtp("web-service/" + message.schemeId + "/" + webService + "?uid=" + device.thrid, serviceData, "POST")
                }
            }
        }
        
        let dependencyServices = (this.threeRadical || {}).depends
        if(dependencyServices){
            for(let dependency in dependencyServices) {
                let depends = dependencyServices[dependency]
                this.services[depends.packageName] = function(serviceData) {
                    return self.device.gtp("web-service/" + message.schemeId + "/" + depends.symbol, serviceData, "POST")
                }
            }
        }
    }
    
    GameDevice.prototype.store = function(data) {
        var instaceId
        var device = this.device
        
        if (this.message) {
            instaceId = this.message.ATTRIBUTES.id || "0"
        } else  {
            instaceId = "0"
        }
        
        if (data) {
            var jsonStr = JSON.stringify(data)
            
            if (jsonStr.length > 5000) {
                return Promise.reject(new Error("Local game storage limit exceeded"))
            }
            
            return this.device.canUpdateData(function () {
                var wfeGameInstance = (device.variables || {}).wfeGameInstance || {}
                
                wfeGameInstance[instaceId] = data
                
                device.variables = {wfeGameInstance : wfeGameInstance}
            })
            
        } else {
            return device.canUpdateData()
                .then(function (){
                    return ((device.variables || {}).wfeGameInstance || {})[instaceId]
                })
        }
    }
    
    GameDevice.prototype.unsafeStore = function (data) {
        var device = this.device
        var instaceId
        var device = this.device
        
        if (this.message) {
            instaceId = this.message.ATTRIBUTES.id || "0"
        } else  {
            instaceId = "0"
        }
        
        if (data) {
            var jsonStr = JSON.stringify(data)
            
            if (jsonStr.length > 10000) {
                throw new Error("Local game storage limit exceeded")
            }
            
            var wfeGameInstance = (device.variables || {}).wfeGameInstance || {}
            wfeGameInstance[instaceId] = data
            device.variables = { wfeGameInstance : wfeGameInstance }
        } else {
            return ((device.variables || {}).wfeGameInstance || {})[instaceId] 
        } 
    }
    
    GameDevice.prototype.unlock = function(code, packet) {
        return this.device.unlock(code, packet)
    }
    
    /* Sub-Packages defined by tactic ID resolve the exact message at runtime.
     * Container packages need the option to set the message.
     */
    
    GameDevice.prototype.triggerOutcomeForMessage = function (value, message) {
        return this.device.unlock('WM.Value', {
            messageId: message.systemId,
            GameEvent: value
        })
    }
    
    GameDevice.prototype.triggerOutcome = function(value, final) {    
        let self = this
    
        if(final) {
            if(this.message.quantities.closeBeforeFinal || final.closeBeforeFinal) {
                this.gameNavigation.next()
                return this.triggerOutcomeForMessage(value, this.message)
            } else {
                let self = this
                return this.triggerOutcomeForMessage(value, this.message).then(function(res) {
                    self.gameNavigation.next()  
                    return res
                })                      
            }
        } else {
            return this.triggerOutcomeForMessage(value, this.message)
        }
    }
    
    function factory(Device, gameNavigation, helperFunctions, message) {
        return new GameDevice(message, gameNavigation, Device, helperFunctions, Device.schemeId)
    }
    
    factory._depends = {
        symbol : "3r/chi/factories/device",
        modules : [
            "3r/Device",
            {
                symbol : "3r/vvm/navigation",
                nullIfMissing : true
            },
            "3r/chi/helpers"
        ]
    }

    if (isNode) {
        module.exports = {
            GameDevice: GameDevice,
            factory : factory
        }
    } else {
        root.GameDevice = GameDevice
    }
})()